<template>
  <b-button
    :block="true"
    style="white-space: normal; height: auto }"
    variant="light"
    class="text-left d-flex justify-content-between"
    @click="$emit('click')"
  >
    <div class="px-2">
      <div class="d-lg-none">
        <span class="fa-stack">
          <span :class="icon_color" class="fas fa-square fa-stack-2x" />
          <span :class="icon_character" class="fas fa-stack-1x fa-inverse" />
        </span>
      </div>
      <div class="d-none d-lg-inline">
        <span class="fa-stack fa-2x">
          <span :class="icon_color" class="fas fa-square fa-stack-2x" />
          <span :class="icon_character" class="fas fa-stack-1x fa-inverse" />
        </span>
      </div>
    </div>

    <div class="d-flex flex-column" style="flex-grow: 1;">
      <slot />
    </div>
    <div
      class="d-flex flex-column justify-content-between align-items-end align-self-stretch"
    >
      <span class="fas fa-chevron-right pl-2 pt-2" aria-hidden="true" />
      <slot name="button" />
    </div>
  </b-button>
</template>

<script>
export default {
  name: 'PanelDescription',
  props: ['icon_color', 'icon_character'],
}
</script>
